export const PortalQueryParams = {
  PRODUCT_ID: "product-id",
  LANGUAGE_CODE: "lang",
} as const;
